import api from "../../../../libs/api";

angular.module("AccountingBoxApp").component("vendorEdit", {
  bindings: {
    vendor: "<",
    onSave: "&",
    onDelete: "&"
  },
  templateUrl: "app/bookkeeper/vendors/edit/edit.html",
  controller: function(Purchase, $scope) {
    var vm = this;
    vm.$onInit = function() {
      // Purchase.find({
      //   filter: {
      //     where: {
      //       vendorId: vm.vendor.id
      //     }
      //   }
      // });
      const loadPurchases = async () => {
        const data=  await api.get(`/Vendors/${vm.vendor.id}/purchases`)
        vm.purchases = data || [];
        setTimeout(() => {
          $scope.$apply();
          $scope.$broadcast('vsRepeatTrigger');
        }, 100);
        $scope.$apply();
        $scope.$broadcast('vsRepeatTrigger');
      }
      loadPurchases();

    };

    vm.purchases = [];

    vm.handleDelete = function() {
      $("#vendorDeleteModal").modal("show");
    };

    vm.getPurchaseType = function(purchase) {
      if (purchase.type === "receipt") {
        return "Bon";
      }
      if (purchase.type === "invoice") {
        return "Factuur";
      }
      return "Onbekend";
    };

    vm.handleDeleteConfirm = function() {
      // $("#vendorDeleteModal").modal("hide");
      vm.onDelete({ vendor: vm.vendor });
    };
  }
});
